var React = require('react');

function Wiki (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M60 246H168L204 282V390L168 426H60L24 390V282L60 246Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M60 24H168L204 60V168L168 204H60L24 168V60L60 24Z","fill":"currentColor","key":1}),React.createElement("path",{"d":"M282 246H390L426 282V390L390 426H282L246 390V282L282 246Z","fill":"currentColor","key":2}),React.createElement("path",{"d":"M282 24H390L426 60V168L390 204H282L246 168V60L282 24Z","fill":"currentColor","key":3})]);
}

Wiki.defaultProps = {"width":"450","height":"450","viewBox":"0 0 450 450","fill":"none"};

module.exports = Wiki;

Wiki.default = Wiki;
